import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Sidebar from "../Sidebar/Sidebar";
import ProfileDropdown from "./ProfileDropdown";
import { PAGE_TITLES } from "../../constants";
import menuIcon from "../../assets/icons/menu.svg";
import { useAppDispatch, useAppSelector, getProfileThunk } from "../../redux";
import "./Layout.css";

const Layout: React.FC = () => {
  const [isCollapsed, setIsCollapsed] = useState<boolean>(false);
  const [isMobileOpen, setIsMobileOpen] = useState<boolean>(false);
  const location = useLocation();

  const dispatch = useAppDispatch();
  const { isAuthenticated, user, isLoading, error } = useAppSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated && !user && !isLoading && !error) {
      dispatch(getProfileThunk());
    }
  }, [dispatch, isAuthenticated, user, isLoading, error]);

  const toggleSidebar = () => {
    setIsCollapsed((prev) => !prev);
  };

  const toggleMobileSidebar = () => {
    setIsMobileOpen((prev) => !prev);
  };

  const closeMobileSidebar = () => {
    setIsMobileOpen(false);
  };

  // Close mobile sidebar on route change
  useEffect(() => {
    setIsMobileOpen(false);
  }, [location.pathname]);

  const currentTitle = PAGE_TITLES[location.pathname] || "Akshar Art Portal";

  return (
    <div className="app-layout">
      {/* Collapsible Sidebar */}
      <Sidebar
        isCollapsed={isCollapsed}
        onToggle={toggleSidebar}
        isMobileOpen={isMobileOpen}
        onMobileClose={closeMobileSidebar}
      />

      {/* Main Content Wrapper */}
      <div className={`main-wrapper ${isCollapsed ? "sidebar-collapsed" : "sidebar-expanded"}`}>
        {/* Top Header */}
        <header className="top-header">
          <div className="header-left">
            <button
              type="button"
              className="mobile-menu-btn"
              onClick={toggleMobileSidebar}
              aria-label="Toggle Navigation Menu"
            >
              <img src={menuIcon} alt="Menu" width={22} height={22} />
            </button>
            <h1 className="header-page-title">{currentTitle}</h1>
          </div>

          <div className="header-right">
            <ProfileDropdown />
          </div>
        </header>

        {/* Page Body */}
        <main className="main-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default Layout;
